const userAgent = navigator.userAgent;

export function isThisIE(): boolean {
  return /Trident|MSIE|IEMobile/i.test(userAgent);
}